
import GwTextImage from '~/patterns/molecules/text-image/text-image.vue';
export default {
    components: {
        GwTextImage
    },
    props: {
        imageFit: {
            type: String,
            default: 'cover'
        }
    }
};
